export const  aggTypes  = [
    { label: $localize`:@@aggTsum:Suma`, value: 'sum' },
    { label: $localize`:@@aggTmean:Media`, value: 'avg' },
    { label: $localize`:@@aggTmax:Máximo`, value: 'max' },
    { label: $localize`:@@aggTmin:Mínimo`, value: 'min' },
    { label: $localize`:@@aggTcount:Cuenta Valores`, value: 'count' },
    { label: $localize`:@@aggTcountD:Valores Distintos`, value: 'count_distinct' },
    { label: 'No', value: 'none' }
];
